import { unwrappedFollowListAtom } from '@/atoms/lists'
import { HugeiconsIcon } from '@hugeicons/react'
import { ContactRound } from '@hugeicons/core-free-icons'
import { useAtomValue } from 'jotai'
import { useTranslation } from 'react-i18next'

export default function FollowingBadge({ pubkey }: { pubkey: string }) {
  const { t } = useTranslation()
  const followList = useAtomValue(unwrappedFollowListAtom)
  const isFollowing = followList?.includes(pubkey) ?? false

  if (!isFollowing) return null

  return (
    <div className="rounded-full bg-muted p-0.5 flex items-center" title={t('You follow')}>
      <HugeiconsIcon icon={ContactRound} className="!size-3" />
    </div>
  )
}
